import React from "react";
import "./style.scss";
import moment from "moment";
import { useSelector } from "react-redux";
import { formatCurrency } from "../../../../utils/helpers/string";
import infoIcon from "../../../../assets/icons/InfoIcon.svg";
import { Tooltip } from "antd";

function Statistic({ accountsData }) {
  const value2 = accountsData.account_metrics;

  const now = new Date();

  const lastUpdated = useSelector(
    (state) => state.account.accountMetrics.lastUpdated
  );
  const options = { timeZoneName: "short" };
  const timeZone = new Intl.DateTimeFormat(undefined, options)
    .formatToParts(now)
    .find((part) => part.type === "timeZoneName").value;

  const breachedReasonMap = {
    one_per_risk_limit: "1% Risk Limit",
    max_d: "Max Drawdown",
    max_dd: "Max Daily Drawdown",
    carry_over: "Carry Over / Weekend Holding",
    min_seven_profitable_days: "Minimum Profitable Days",
    stopout: "stopout",
  };

  return (
    <div className="statistic-container">
      <div className="statistic-subcontainer">
        <h4>Statistics</h4>
        <div>
          <div>
            <p
              className={
                Number(accountsData?.balance_equity?.equity) < 0
                  ? "loss"
                  : "profit"
              }
            >
              $
              {accountsData?.balance_equity?.equity != null &&
              !isNaN(Number(accountsData?.balance_equity?.equity))
                ? Number(accountsData?.balance_equity?.equity).toFixed(2)
                : "0.00"}
            </p>
            <h5>Equity</h5>
          </div>

          <div>
            <p
              className={
                accountsData?.balance_equity?.balance < 0 ? "loss" : "profit"
              }
            >
              ${accountsData?.balance_equity?.balance}
            </p>
            <h5>Balance</h5>
          </div>
          <div>
            <p>{value2?.number_of_trades}</p>
            <h5>No. of trade</h5>
          </div>
          <div>
            <p>{value2?.lots?.toFixed(2)}</p>
            <h5>Lots</h5>
          </div>
          <div>
            <p>{Math.trunc(value2?.win_rate * 100) / 100}</p>
            <h5>Win Rate</h5>
          </div>
          <div>
            <p>{value2?.profit_target?.toFixed(2)}</p>
            <h5>Profit Target</h5>
          </div>
          <div>
            <p
              className={
                accountsData?.account_metrics?.avg_win < 0 ? "loss" : "profit"
              }
            >
              {accountsData?.account_metrics?.avg_win}
            </p>
            <h5>Average profit</h5>
          </div>
          <div>
            <p className={value2?.avg_loss ? "loss" : "profit"}>
              {value2?.avg_loss?.toFixed(2)}
            </p>
            <h5>Average loss</h5>
          </div>
          <div>
            <p>{value2?.rrr}</p>
            <h5>Average RRR</h5>
          </div>
          <div>
            <p>{value2?.expectancy}</p>
            <h5>Expectancy</h5>
          </div>
          <div>
            <p>{value2?.profit_factor}</p>
            <h5>Profit factor</h5>
          </div>
          <div>
            {/* <p>{value2?.interest}</p>
          <h5>Interest</h5> */}
          </div>
        </div>
      </div>
      <div className="statistic-subcontainer">
        <div>
          {accountsData?.status !== "in_progress" && (
            <>
              {" "}
              {accountsData?.status === "passed" && (
                <>
                  <div>
                    <p>
                      {moment
                        .utc(accountsData?.program_objectives?.passed_at)
                        .format("DD-MM-YYYY") || 0}
                    </p>
                    <h5>Passed At</h5>
                  </div>
                  <div>
                    <p>
                      {formatCurrency(
                        accountsData?.program_objectives?.passed_balance
                      ) || 0}
                    </p>
                    <h5>Passed Balance</h5>
                  </div>
                  <div>
                    <p>
                      {formatCurrency(
                        accountsData?.program_objectives?.passed_equity
                      ) || 0}
                    </p>
                    <h5>Passed Equity</h5>
                  </div>
                </>
              )}
              {accountsData?.status === "failed" && (
                <>
                  {" "}
                  <div>
                    <p>
                      {moment
                        .utc(accountsData?.program_objectives?.breached_at)
                        .format("DD-MM-YYYY") || 0}
                    </p>
                    <h5>Breached At</h5>
                  </div>
                  <div>
                    <p>
                      {formatCurrency(
                        accountsData?.program_objectives?.breached_balance
                      ) || 0}
                    </p>
                    <h5>Breached Balance</h5>
                  </div>
                  <div>
                    <p>
                      {formatCurrency(
                        accountsData?.program_objectives?.breached_equity
                      ) || 0}
                    </p>
                    <h5>Breached Equity</h5>
                  </div>
                  {accountsData?.program_objectives?.breached_reason && (
                    <div>
                      <p>
                        {breachedReasonMap[
                          accountsData?.program_objectives?.breached_reason
                        ] || "N/A"}
                      </p>
                      <h5>Breached Reason</h5>
                    </div>
                  )}
                </>
              )}
            </>
          )}
          <div>
            <p>
              {moment
                .utc(accountsData?.program_objectives?.reset_at)
                .format("DD-MM-YYYY") || 0}
            </p>
            <h5>Reset At</h5>
          </div>
          <div>
            <p>
              {formatCurrency(
                accountsData?.program_objectives?.reset_balance
              ) || 0}
            </p>
            <h5>Reset Balance</h5>
          </div>
          <div>
            <p>
              {formatCurrency(accountsData?.program_objectives?.reset_equity) ||
                0}
            </p>
            <h5>Reset Equity</h5>
          </div>
          {accountsData?.plan_name === "Instant" &&
            accountsData?.program_objectives?.best_day_profit && (
              <div style={{ position: "relative" }}>
                <p>
                  {formatCurrency(
                    accountsData?.program_objectives?.best_day_profit
                  ) || "N/A"}
                </p>
                <h5>Best Day Profit</h5>
                <Tooltip
                  title={
                    accountsData?.program_objectives?.best_day_date ||
                    "No date available"
                  }
                  placement="top"
                  color="#000"
                >
                  <img
                    src={infoIcon}
                    alt="info"
                    style={{
                      width: 16,
                      height: 16,
                      cursor: "pointer",
                      marginLeft: 6,
                      background: "#fff",
                      borderRadius: "50%",
                      border: "1px solid #2091eb",
                      verticalAlign: "middle",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "absolute",
                      left: "55px",
                    }}
                  />
                </Tooltip>
              </div>
            )}
        </div>
      </div>

      <div className="statistic-details">
        <p>
          Timezone : <span>{timeZone}</span>
        </p>
        <p className="last_update">
          Last Updated : <span>{lastUpdated}</span>
        </p>
      </div>
    </div>
  );
}

export default Statistic;
